import store from '@/store'
import { setUserToken } from '@/utils/localStorage'

export default async (to, from, next) => {
  try {
    store.dispatch('wait/start', 'app loading', { root: true })

    if (to.query.redirectLineOaId) {
      const { userToken: newUserToken } = await store.dispatch('Auth/chooseLineAccount', {
        lineOfficialAccountId: to.query.redirectLineOaId
      })
      setUserToken(newUserToken)
    }

    if (store.getters['User/isUserProfileEmpty']) {
      await store.dispatch('User/fetchProfile')
    }

    next()
  } catch (error) {
    throw new Error(error)
  } finally {
    store.dispatch('wait/end', 'app loading', { root: true })
  }
}
